import { render, staticRenderFns } from "./LvBatchAddMemberCard.vue?vue&type=template&id=66545fd6"
import script from "./LvBatchAddMemberCard.vue?vue&type=script&lang=js"
export * from "./LvBatchAddMemberCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports